import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://d948138b0fced8defb8d9bb6bfdf0a4f@o4509095346896896.ingest.us.sentry.io/4509748769193984",
  
  // Environment configuration
  environment: import.meta.env.MODE || "development",
  debug: false,
  
  // Performance monitoring
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
      autoInject: false,
    }),
  ],
  
  // Performance sampling rates - increased for better error visibility
  tracesSampleRate: import.meta.env.MODE === "development" ? 1.0 : 0.5,
  
  // Session replay sampling - increased for better error visibility  
  replaysSessionSampleRate: import.meta.env.MODE === "development" ? 1.0 : 0.5,
  replaysOnErrorSampleRate: 1.0, // Always capture replay on errors
  
  // User data
  sendDefaultPii: true,
  
  // Filter errors in production
  beforeSend(event) {
    return event;
  }
});

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Sentry.ErrorBoundary 
    fallback={({ error, resetError }) => (
      <div style={{ 
        padding: "20px", 
        textAlign: "center", 
        fontFamily: "system-ui, sans-serif",
        backgroundColor: "#f8f9fa",
        minHeight: "100vh", 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "center",
        alignItems: "center"
      }}>
        <h2 style={{ color: "#dc3545", marginBottom: "16px" }}>Something went wrong!</h2>
        <p style={{ color: "#6c757d", marginBottom: "24px", maxWidth: "400px" }}>
          An error occurred in the application. This has been reported to our team.
        </p>
        <button 
          onClick={resetError}
          style={{
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "16px"
          }}
        >
          Try again
        </button>
        {import.meta.env.MODE === "development" && (
          <details style={{ marginTop: "20px", textAlign: "left" }}>
            <summary style={{ cursor: "pointer", marginBottom: "8px" }}>Error Details (Development)</summary>
            <pre style={{ 
              backgroundColor: "#f8f9fa", 
              padding: "12px", 
              borderRadius: "4px", 
              fontSize: "12px",
              overflow: "auto",
              maxWidth: "600px"
            }}>
              {error instanceof Error ? error.toString() : String(error)}
            </pre>
          </details>
        )}
      </div>
    )}
    showDialog
  >
    <App />
  </Sentry.ErrorBoundary>
);
